export default "__VITE_ASSET__yB2NvDm$__"